import { render, staticRenderFns } from "./ClientOrderUnauthorized.vue?vue&type=template&id=3896a12e&scoped=true"
import script from "./ClientOrderUnauthorized.vue?vue&type=script&lang=js"
export * from "./ClientOrderUnauthorized.vue?vue&type=script&lang=js"
import style0 from "./ClientOrderUnauthorized.vue?vue&type=style&index=0&id=3896a12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3896a12e",
  null
  
)

export default component.exports